
import { Component, Mixins, Provide } from "vue-property-decorator";

@Component({
})
export default class ModalPresentableMixin extends Mixins() {
  @Provide("parentModal")
  symbol: symbol = Symbol();
  
  beginModal(): void {
    this.$store.commit("setPdfViewerVisibleControlObject", { symbol: this.symbol, isDelete: false, isTransparent: false });
  }

  endModal(): void {
    this.$store.commit("setPdfViewerVisibleControlObject", { symbol: this.symbol, isDelete: true, isTransparent: false });
  }

  updateModal(isTransparent: boolean): void {
    this.$store.commit("setPdfViewerVisibleControlObject", { symbol: this.symbol, isDelete: false, isTransparent: isTransparent });
  }

  destroyed(): void {
    this.$store.commit("setPdfViewerVisibleControlObject", { symbol: this.symbol, isDelete: true, isTransparent: false });
  }
}
